<div class="flex-auto input-field-container {{field.customClass}}" *ngIf="field">
	<label [hidden]="field.UIOptions && field.UIOptions.showLabel === false">{{ fieldOptions.label || field.DisplayText }}</label>
	<ng-container [ngSwitch]="field.DataType">

		<ng-container *ngSwitchCase="'Text'">
			<textarea
				class="form-control"
				rows="5"
				[formControl]="control"
				(blur)="onChange($event)"
				(keyup)="onKeyup($event)">
			</textarea>
		</ng-container>

		<ng-container *ngSwitchDefault>
			<div *ngIf="field.UIOptions?.GroupElement; else simpleInputTemplate" class="p-inputgroup">
				<span *ngIf="['left','both'].includes(field.UIOptions?.GroupElement.Type)" class="p-inputgroup-addon">
					{{ field.UIOptions.GroupElement.LeftElement.text }}
					<i *ngIf="field.UIOptions.GroupElement.LeftElement.icon"
					   class="{{field.UIOptions.GroupElement.LeftElement.icon}}"></i>
				</span>
				<ng-container *ngTemplateOutlet="simpleInputTemplate"></ng-container>

				<span *ngIf="['right','both'].includes(field.UIOptions?.GroupElement.Type)" class="p-inputgroup-addon">
					{{ field.UIOptions.GroupElement.RightElement.text }}
					<i *ngIf="field.UIOptions.GroupElement.RightElement.icon" class="{{ field.UIOptions.GroupElement.RightElement.icon }}"></i>
				</span>
			</div>
		</ng-container>
	</ng-container>
</div>

<ng-template #simpleInputTemplate>
	<input
		*ngIf="field.DataType === 'String'"
		[placeholder]="fieldOptions.label || ''"
		type="text"
		class="form-control"
		[formControl]="control"
		(blur)="onChange($event)"
		(keyup)="onKeyup($event)">

	<ng-container *ngIf="['Integer', 'Numeric'].includes(field.DataType) ? field.DataType : ''">
		<input
			*ngIf="field.SubDataType !== 'input-number'"
				class="form-control"
			   type="number"
			   [min]="min"
			   [max]="max"
			   [formControl]="control"
			   (blur)="onChange($event)"
			   (keydown)="onKeyDownNumeric($event)"
			   [ngClass]="{
					   'form-control-with-postfix': fieldOptions.postfix,
					   'form-control-with-prefix': fieldOptions.prefix,
					   'single-field': fieldOptions.publicRecordMultiple === 'single'
					}"/>

		<p-inputNumber
			*ngIf="field.SubDataType === 'input-number'"
			[min]="field.UIOptions.min"
			[max]="field.UIOptions.max"
			[suffix]="field.UIOptions.suffix"
			[prefix]="field.UIOptions.prefix"
			[formControl]="control"
			[readonly]="field.UIOptions.readonly"
		></p-inputNumber>
	</ng-container>
</ng-template>
